const idle = {
  images: [require('assets/sprites/dodo/anger.png')],

  framerate: 10,
  frames: [
    [1087, 1, 235, 208, 0, 117.5, 208], //1
    [314, 1, 260, 229, 0, 130, 229], //2
    [576, 1, 260, 229, 0, 130, 229], //3
    [820, 232, 258, 227, 0, 129, 227], //4
    [1, 233, 257, 224, 0, 128.5, 224], //5
    [1080, 221, 250, 217, 0, 125, 217], //7
    [260, 233, 257, 222, 0, 128.5, 222], //6
    [1, 1, 311, 230, 0, 173, 222], //8
    [519, 232, 299, 227, 0, 170, 220], //9
    [838, 1, 247, 218, 0, 123.5, 218], //10
    [1324, 1, 253, 205, 0, 126.5, 205], //11
    [1332, 208, 241, 192, 0, 120.5, 192], //12
    [1087, 1, 235, 208, 0, 117.5, 208] //13
  ],

  animations: {
    'anger(8)': { frames: [0] },
    'anger(5)': { frames: [1] },
    'anger(6)': { frames: [2] },
    'anger(2)': { frames: [3] },
    'anger(9)': { frames: [4] },
    'anger(3)': { frames: [5] },
    'anger(4)': { frames: [6] },
    'anger(10)': { frames: [7] },
    'anger(7)': { frames: [8] },
    'anger(1)': { frames: [9] },
    'anger(13)': { frames: [10] },
    'dead(1)': { frames: [11] },
    'anger(11)': { frames: [12] },
    'anger(12)': { frames: [13] }
  }
};
const walk = {
  images: [require('assets/sprites/dodo/light.png')],

  framerate: 10,
  frames: [
    [500, 272, 234, 208, 0, 106, 142], //1
    [255, 272, 243, 210, 0, 111, 149], //2
    [1, 272, 252, 228, 0, 115, 157], //3
    [736, 268, 257, 231, 0, 118, 160], //4
    [1524, 236, 256, 230, 0, 117, 163], //5
    [995, 265, 264, 235, 0, 119, 161], //6
    [1261, 248, 261, 239, 0, 125, 165], //7
    [1326, 1, 259, 233, 0, 120, 166], //8
    [1066, 1, 258, 245, 0, 121, 169], //9
    [271, 1, 261, 269, 0, 119, 195], //10
    [534, 1, 260, 265, 0, 122, 199], //11
    [1, 1, 268, 269, 0, 131, 203], //12
    [796, 1, 268, 262, 0, 134, 198] //13
  ],

  animations: {
    'light(12)': { frames: [0] },
    'light(3)': { frames: [1] },
    'light(2)': { frames: [2] },
    'light(10)': { frames: [3] },
    'light(1)': { frames: [4] },
    'light(11)': { frames: [5] },
    'light(4)': { frames: [6] },
    'light(13)': { frames: [7] },
    'light(6)': { frames: [8] },
    'light(9)': { frames: [9] },
    'light(7)': { frames: [10] },
    'light(8)': { frames: [11] },
    'light(5)': { frames: [12] }
  }
};
const dead = {
  images: [require('assets/sprites/dodo/dead.png')],

  framerate: 10,
  frames: [
    [267, 1, 235, 208, 0, 117.5, 208], //1
    [1, 622, 264, 188, 0, 132, 188], //2
    [1, 429, 264, 191, 0, 132, 191], //3
    [1, 812, 263, 196, 0, 131.5, 196], //4
    [1, 225, 264, 202, 0, 132, 202], //5
    [1, 1, 264, 222, 0, 132, 222], //6
    [266, 812, 151, 128, 0, 75.5, 128], //7
    [267, 686, 147, 119, 0, 73.5, 119], //8,
    [267, 566, 156, 118, 0, 78, 118], //9
    [267, 445, 166, 119, 0, 83, 119], //10
    [267, 325, 174, 118, 0, 87, 118], //11
    [267, 211, 176, 112, 0, 88, 112] //12
  ],

  animations: {
    'dead(6)': { frames: [0] },
    'dead(1)': { frames: [1] },
    'dead(12)': { frames: [2] },
    'dead(5)': { frames: [3] },
    'dead(11)': { frames: [4] },
    'dead(3)': { frames: [5] },
    'dead(10)': { frames: [6] },
    'dead(9)': { frames: [7] },
    'dead(2)': { frames: [8] },
    'dead(4)': { frames: [9] },
    'dead(7)': { frames: [10] },
    'dead(8)': { frames: [11] }
  }
};
const dodo2 = {
  idle,
  walk,
  dead
};
export default dodo2;
